import { render } from "./SeatPermissionAdd.vue?vue&type=template&id=77f62644&scoped=true"
import script from "./SeatPermissionAdd.vue?vue&type=script&lang=js"
export * from "./SeatPermissionAdd.vue?vue&type=script&lang=js"

import "./SeatPermissionAdd.vue?vue&type=style&index=0&id=77f62644&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f62644"]])

export default __exports__